// extracted by mini-css-extract-plugin
export default {"table":"CellWebExportPage_table__x+7xG","cellWebExportTable":"CellWebExportPage_cellWebExportTable__67Diw","cellWebExport":"CellWebExportPage_cellWebExport__il2U7"};